import { validateTyreCatalogue } from '../data/validate';

/** The legacy engine accepts concepts; the active product showcase requires provenance. */
export function validateGameCatalogue(data: unknown) {
  const catalogue = validateTyreCatalogue(data);
  if (catalogue.tyres.some(t => t.placeholder || !t.product || t.disciplines.some(d => !['mtb', 'bmx', 'road'].includes(d)))) throw new Error('The showcase requires verified cycling products with international pricing.');
  if (!['mtb', 'bmx', 'road'].every(d => catalogue.tyres.some(t => (t.disciplines as string[]).includes(d)))) throw new Error('The catalogue needs tyres for all three cycling disciplines.');
  return catalogue;
}
